<template>
  <li @click="navigateTo">
    <img :src="isActive ? iconImgActive : iconImg" alt="" />
    <p>{{ name }}</p>
  </li>
</template>

<script>
export default {
  name: "TabItem",
  props: {
    iconImg: {
      type: String,
      default: ""
    },
    iconImgActive: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    routeName: {
      type: String,
      default: ""
    }
  },
  computed: {
    isActive() {
      return this.$route.name === this.routeName;
    }
  },
  methods: {
    navigateTo() {
      this.$router.push({ name: this.routeName });
    }
  }
};
</script>

<style lang="scss" scoped>
li {
  width: 20%;
  line-height: 10px;
  img {
    width: 30px;
    height: 30px;
  }
  p {
    margin: 0;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
    color: rgba(115, 115, 115, 1);
  }
}
</style>
